module.exports = __webpack_public_path__ + "img/penilaian.e1fdc3a2.svg";